module.exports = __webpack_public_path__ + "media/errors/404-colleges-8790d931.png";